<template>
  <v-layout column  pa-0 >
    <v-layout column fill-height class="terminal" ma-0 pt-1>
      <div style="height: 100%" ref="terminal"></div>
    </v-layout>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from 'xterm-addon-fit'
import { SearchAddon } from 'xterm-addon-search'
import { io, Socket } from 'socket.io-client'
import { getURL } from '@/nms/plugins/bridge.js'

// Типы
interface ConsoleData {
  $id?: string
  cls?: string
  [key: string]: any
}

interface TaskData {
  id: string | null
  name: string | null
  accepts: Record<string, any>
}

export default Vue.extend({
  name: 'CONSOLE',

  components: {},

  props: {
    data: {
      type: Object as () => ConsoleData,
      default: () => ({})
    },
  },

  data(): {
    popCommands: string[]
    commandHistory: string[]
    historyCounter: number
    data$id: string | null
    terminalInstance: Terminal | null
    task: TaskData
  } {
    return {
      popCommands: ['Виталий, делай вещи!', 'command', 'showDictionary'],
      commandHistory: [],
      historyCounter: 0,
      data$id: null,
      terminalInstance: null,
      task: {
        id: null,
        name: null,
        accepts: {}
      },
    }
  },

  computed: {
    getData(): ConsoleData {
      return this.data
    },
  },

  watch: {
    data: {
      handler(newVal: ConsoleData): void {
        if (newVal.$id && this.data$id !== newVal.$id) {
          this.data$id = newVal.$id
          if (this.terminalInstance) {
            this.terminalInstance.dispose()
          }
          this.initTerminal(this.data.$id, 'watch data')
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    console.log(this.$options.name, 'mounted', 'data', this.data)
    if (this.data.cls && this.data.$id && this.data$id !== this.data.$id) {
      this.data$id = this.data.$id
      this.initTerminal(this.data.$id, 'mounted')
    }
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },

    async initTerminal(id: string, caller: string): Promise<void> {
      try {
        const $url = getURL('bridge')
        // console.log(this.$options.name, 'INIT_TERMINAL', 'getURL', $url)

        const socket: Socket = io($url + '/terminal', {
          path: '/e-data-front/socket.io/'
        })

        this.terminalInstance = new Terminal({
          cursorBlink: true,
          fontSize: 14,
          theme: {
            background: '#1e1e1e',
            foreground: '#ffffff'
          }
        })

        this.terminalInstance.open(this.$refs['terminal'] as HTMLElement)
        // console.log(this.$options.name, 'INIT_TERMINAL', 'this.terminalInstance', this.terminalInstance)

        socket.on('terminal_message', (data: string) => {
          this.terminalInstance?.write(data)
        })

        this.terminalInstance.onData((data: string) => {
          socket.emit('terminal_message', data)
        })

        this.terminalInstance.onResize((size: { rows: number; cols: number }) => {
          socket.emit('resize', size)
        })

        socket.on('connect', () => {
          socket.emit('terminal_message', id)
        })
      } catch (error) {
        console.error(this.$options.name, 'INIT_TERMINAL', 'smth wrong', error)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="css" scoped>
.customToolbar {
  background-color: #58595B;
  height: 48px;
  font-size: 20px;
  font-weight: 500;
}

.terminal {
    background-color: #000000;
    color: #fafafa;
    padding: 2px;
    position: absolute; 
    height: 100%;
    width: 100%;
    /* height: calc(100% - 19px); */
  }
</style>
